module.exports = __webpack_public_path__ + "img/pedja-savovic.eb761c54.jpg";